import { FunctionComponent, useEffect } from 'react'
import { ActiveUserJourney, syncActiveJourney, useAppDispatch } from '../../state'
import { UserJourney } from './types'
import { useUserJourneyContext } from './UserJourneyContext'

const toActiveJourney = (journey: UserJourney | undefined): ActiveUserJourney | undefined =>
  journey === undefined
    ? undefined
    : {
        name: journey.name,
        journeyId: journey.id,
        createdAt: journey.created,
        variant: journey.variant,
        tags: journey.tags,
        frustrations: journey.frustrations,
        frictions: journey.frictions,
      }

export const UserJourneyStateSync: FunctionComponent = () => {
  const { active, subscribe } = useUserJourneyContext()
  const dispatch = useAppDispatch()

  useEffect(
    () =>
      subscribe(({ state }) => {
        dispatch(syncActiveJourney(toActiveJourney(state.active !== undefined ? state.journeys[state.active] : undefined)))
      }),
    [subscribe, dispatch]
  )

  useEffect(() => {
    dispatch(syncActiveJourney(toActiveJourney(active)))
  }, [active, dispatch])

  return null
}
